export default [
  {
    name: `splash_screen`,
    title: `La Ferme Verticale`,
    lang: `Choisissez votre <br /><span i>langue</span>`,
  },
];
